import {
    Button,
    createListCollection,
    Grid,
    GridItem,
    Input,
    Portal,
    Select,
} from "@chakra-ui/react";
import { React, useContext, useState } from "react";

import { context } from "@/context/valuationContext";

const Caracteristicas = ({ isGreaterThanMd }) => {
    //Context
    const { addDataFeatures, step, updateStep } = useContext(context);

    //Elementos para guardar la info de elementos
    const [age, setAge] = useState(null);
    const [garage, setGarage] = useState(null);
    const [bedroom, setBedroom] = useState(null);
    const [bathrooms, setBathrooms] = useState(null);
    const [half_bathrooms, setHalf_bathrooms] = useState(null);
    const [floorsNumber, setFloorsNumber] = useState(null);
    const [conservation, setConservation] = useState(null);

    const conservationStateOptions = createListCollection({
        items: [
            { value: 1, label: "Nuevo" },
            { value: 2, label: "Muy Bueno" },
            { value: 3, label: "Bueno" },
            { value: 4, label: "Regular" },
            { value: 5, label: "Malo" },
        ],
    });

    const handleSubmit = () => {
        const data = {
            age: Number(age),
            garage: Number(garage),
            bedroom: Number(bedroom),
            bathrooms: Number(bathrooms),
            half_bathrooms: Number(half_bathrooms),
            floors_number: Number(floorsNumber),
            conservation: Number(conservation),
        };

        addDataFeatures(data);
        updateStep(step + 1);
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Grid templateColumns="repeat(3, 1fr)" gap={10} alignItems="center" mt={2}>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="Edad"
                        type="number"
                        rounded="full"
                        placeholder="Edad*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setAge(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="Cochera"
                        type="number"
                        rounded="full"
                        placeholder="Cochera*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setGarage(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="Recamaras"
                        type="number"
                        rounded="full"
                        placeholder="Recámaras*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setBedroom(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="Banos"
                        type="number"
                        rounded="full"
                        placeholder="Baños*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setBathrooms(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="MediosBanos"
                        type="number"
                        rounded="full"
                        placeholder="Medios Baños*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setHalf_bathrooms(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Input
                        id="NumPisos"
                        type="number"
                        rounded="full"
                        placeholder="Número de pisos*"
                        fontSize="sm"
                        color="gray.600"
                        onChange={(e) => {
                            setFloorsNumber(e.target.value);
                        }}
                        required
                        px={4}
                    />
                </GridItem>
                <GridItem colSpan={isGreaterThanMd ? 1 : 3} textAlign="-webkit-left">
                    <Select.Root
                        collection={conservationStateOptions}
                        id="estado_conservacion"
                        rounded="full"
                        fontSize="sm"
                        color="gray.600"
                        required
                        onValueChange={(details) => {
                            setConservation(details.value[0]);
                        }}
                    >
                        <Select.HiddenSelect />
                        <Select.Control>
                            <Select.Trigger rounded="full" pl={4}>
                                <Select.ValueText placeholder="Estado de conservación*" />
                            </Select.Trigger>
                            <Select.IndicatorGroup pr={4}>
                                <Select.Indicator />
                            </Select.IndicatorGroup>
                        </Select.Control>
                        <Portal>
                            <Select.Positioner>
                                <Select.Content p={2}>
                                    {conservationStateOptions.items.map((option) => (
                                        <Select.Item
                                            item={option}
                                            key={option.value}
                                            p={1}
                                            color="gray.600"
                                        >
                                            {option.label}
                                            <Select.ItemIndicator />
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Positioner>
                        </Portal>
                    </Select.Root>
                </GridItem>
                <GridItem colSpan={3} textAlign="-webkit-right" mt={6}>
                    <Button
                        rounded="full"
                        colorPalette="brand"
                        bg="brand.500"
                        color="black"
                        border="0"
                        px="16"
                        _hover={{ bg: "brand.600" }}
                        type="submit"
                    >
                        Siguiente
                    </Button>
                </GridItem>
            </Grid>
        </form>
    );
};

export default Caracteristicas;
